import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  align-items: center;
  text-transform: capitalize;
  flex-wrap: wrap;

  fuel-tooltip {
    text-transform: none;
  }
`;
